import { setFilters, useCustomersFilters } from "modules/CustomersDashboard/components/CustomerFilters/hooks";
import { PAGE_SIZE } from "utils/common";

import type { OnChangeFn, PaginationState } from "@tanstack/react-table";

export const useCustomersTableHandlers = () => {
  const { filters } = useCustomersFilters();

  const onPageChange = (activePage: { page: number }) => setFilters({ ...filters, ...activePage });
  const handlePaginationChange: OnChangeFn<PaginationState> = updater => {
    const newState = typeof updater === "function" ? updater({ pageIndex: (filters.page ?? 1) - 1, pageSize: filters.page_size ?? PAGE_SIZE.PageSize25 }) : updater;
    onPageChange({ page: newState.pageIndex + 1 });
  };
  const handlePageSizeChange = (pageSize: PAGE_SIZE) => setFilters({ ...filters, page_size: pageSize, page: 1 });

  return { handlePaginationChange, handlePageSizeChange };
};
